// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".date[data-v-80c66530]  .el-form-item__content {\n  width: 8em;\n}", ""]);
// Exports
module.exports = exports;
